// extracted by mini-css-extract-plugin
export var numpadContainer = "_kn-1";
export var phoneButton = "_kn-0";